import React from "react";
import { CheckCircle2 } from "lucide-react";

const money = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const Invoice = ({ booking }) => {
  const extrasTotal = booking.extras.reduce((s, x) => s + Number(x.cost || 0), 0);
  const grand = booking.baseDiagnostic + booking.inspectionFee + extrasTotal;

  const dt = new Date(booking.completedAt || Date.now());
  const dateStr = dt.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="card p-8 relative" data-testid={`invoice-${booking.id}`}>
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <div className="font-display text-3xl text-[var(--ink-1)]">
            MrLappy<span className="text-[var(--brand)]">.</span>
          </div>
          <div className="text-xs uppercase tracking-wider text-[var(--ink-3)] mt-2 font-semibold">
            Official service invoice
          </div>
        </div>
        <div className="text-right">
          <div className="text-xs uppercase tracking-wider text-[var(--ink-3)] font-semibold">
            Invoice #
          </div>
          <div className="text-[var(--brand-deep)] text-lg font-semibold">{booking.id}</div>
          <div className="text-xs text-[var(--ink-3)] mt-1">{dateStr}</div>
        </div>
      </div>

      <div className="divider-dashed my-6" />

      <div className="grid md:grid-cols-2 gap-6 text-sm">
        <div>
          <div className="text-xs uppercase tracking-wider text-[var(--ink-3)] font-semibold mb-1">
            Billed to
          </div>
          <div className="text-[var(--ink-1)] font-medium">+91 {booking.phone}</div>
          <div className="text-[var(--ink-2)] mt-1 leading-relaxed">{booking.address}</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-[var(--ink-3)] font-semibold mb-1">
            Device
          </div>
          <div className="text-[var(--ink-1)] font-medium">
            {booking.brand} · <span className="text-[var(--ink-2)]">{booking.model}</span>
          </div>
          <div className="text-xs uppercase tracking-wider text-[var(--ink-3)] font-semibold mt-3 mb-1">
            Issue reported
          </div>
          <div className="text-[var(--ink-1)]">
            {booking.issue === "None of the Above / Other Issue" && booking.customIssue
              ? booking.customIssue
              : booking.issue}
          </div>
        </div>
      </div>

      <div className="divider-dashed my-6" />

      <div className="overflow-hidden rounded-xl border border-[var(--line)]">
        <div className="grid grid-cols-12 py-2.5 px-4 bg-[var(--bg-soft)] text-xs uppercase tracking-wider text-[var(--ink-3)] font-semibold">
          <div className="col-span-8">Description</div>
          <div className="col-span-4 text-right">Amount (₹)</div>
        </div>
        <div className="divide-y divide-[var(--line)]">
          <div className="grid grid-cols-12 py-3 px-4 text-sm">
            <div className="col-span-8 text-[var(--ink-1)]">
              Base repair package · diagnosis charge
            </div>
            <div className="col-span-4 text-right font-semibold text-[var(--ink-1)]">
              {money(booking.baseDiagnostic)}
            </div>
          </div>
          <div className="grid grid-cols-12 py-3 px-4 text-sm">
            <div className="col-span-8 text-[var(--ink-1)]">
              Fixed doorstep inspection &amp; visit fee
            </div>
            <div className="col-span-4 text-right font-semibold text-[var(--ink-1)]">
              {money(booking.inspectionFee)}
            </div>
          </div>
          {booking.extras.map((x) => (
            <div key={x.id} className="grid grid-cols-12 py-3 px-4 text-sm">
              <div className="col-span-8 text-[var(--ink-1)]">{x.name}</div>
              <div className="col-span-4 text-right font-semibold text-[var(--ink-1)]">
                {money(x.cost)}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6 grid md:grid-cols-2 gap-6 items-end">
        <div>
          <span className="paid-stamp inline-flex items-center gap-2">
            <CheckCircle2 size={16} /> TRANSACTION SETTLED / PAID
          </span>
          <div className="text-xs text-[var(--ink-3)] mt-3">
            Handover code verified · Order {booking.id}
          </div>
        </div>
        <div className="card-success p-5 rounded-2xl">
          <div className="text-xs uppercase tracking-wider text-[#166534] font-semibold mb-1">
            Grand total
          </div>
          <div className="font-display text-4xl text-[#166534]">{money(grand)}</div>
          <div className="text-xs text-[#166534]/80 mt-2">Includes all itemized parts &amp; services</div>
        </div>
      </div>

      <div className="divider-dashed my-6" />
      <div className="flex flex-wrap items-center justify-between gap-3 text-xs text-[var(--ink-3)]">
        <div>MrLappy</div>
        <div>mrlappyservice@gmail.com</div>
      </div>
    </div>
  );
};
